import React, { PureComponent, Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import * as faIcon from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChangePassword from '../Layouts/modals/ChangePassword';
import UserDetails from '../Layouts/modals/UserDetails';
import moment from "moment";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import $ from "jquery";
import Parser from 'html-react-parser';
import Switch from "react-switch";
import { logout, mutesound, autoassign, setfullstory, setLeadProcessStatus } from '../../Store/actions/loginActions';
import { AJAX_REQUEST, APP_VERSION, sentryErrorLog } from '../../Constants/AppConstants';

class Header extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showusermenu: false,
            page: '',
            menus: [],
            show_header: true,
            isMute: false,
            isAutoAssignable: false,
            isFullStory: "hide" // hide, yes, no
        }

        setInterval(function () {
            if (this.props.auth) {
                if (this.props.auth.user) {
                    if (this.props.auth.user.remember) {
                        AJAX_REQUEST("POST", "operator/updateAccessToken", {}).then(results => {

                            // Sentry Log create
                            sentryErrorLog(results);

                            if (parseInt(results.response.code) === 1000) {
                                // console.log(results.response.code);
                            }
                        });
                    }
                }
            }
        }.bind(this), 540000);
    }

    showMenu = () => {
        this.setState({
            showusermenu: this.state.showusermenu ? false : true
        });
    }

    showMobSideMenu = () => {
        $("body").toggleClass("current", 1000);
    }

    logout = (e) => {
        e.preventDefault();
        setTimeout(() => {
            AJAX_REQUEST("POST", "operator/logout", {}).then(results => {

                // Sentry Log create
                sentryErrorLog(results);

                if (parseInt(results.response.code) === 1000) { } else {
                    // console.log(results.response.message);
                }
            });
            this.props.logout();
            localStorage.setItem("idleTimeLeft", 0);
            localStorage.removeItem('settings');
        }, 1000)
        let disconnect_exists = document.getElementById("disconnectSocket");
        if (disconnect_exists) {
            disconnect_exists.click();
        }
    }

    setMute = () => {
        let status = this.state.isMute;
        this.setState({ isMute: !status });
        this.props.mutesound(!status);
    }

    setisAutoAssignable = () => {
        let status = this.state.isAutoAssignable;
        this.setState({ isAutoAssignable: !status });
        this.props.autoassign(!status);
    }

    setisFullStory = () => {
        let status = this.state.isFullStory;
        this.setState({ isFullStory: status === "no" ? "yes" : "no" }, () => {
            this.props.setfullstory(status === "no" ? "yes" : "no");
        });

    }

    getTimeNow = () => {
        let la_time_moment = moment().tz('America/Los_Angeles').format("YYYY-MM-DD HH:mm:ss");
        var elementExists = document.getElementById("timenow");
        if (elementExists) {
            la_time_moment = moment().tz('America/Los_Angeles').format("YYYY-MM-DD HH:mm:ss");
            document.getElementById("timenow").innerHTML = "<strong>System Time: </strong>" + la_time_moment + " (Los Angeles)";
        }
    }

    componentDidMount() {
        setTimeout(() => {
            var elementExists = document.getElementById("timenow");
            if (elementExists) {
                this.getTimeNow();
            }
        }, 3000);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.auth) {
            if (this.props.auth.isAuthenticated) {
                this.setState({
                    isAutoAssignable: this.props.auth.isAutoAssignable,
                    isFullStory: this.props.auth.isFullStory
                })
            }
        }
    }

    toggleHeader = () => {
        this.setState({
            show_header: !this.state.show_header
        });
        $("body").toggleClass("header-hide");
    }



    render() {
        const email = this.state.page.hasOwnProperty('email') ? Parser(this.state.page.email) : '';
        const phone = this.state.page.hasOwnProperty('phone') ? Parser(this.state.page.phone) : '';

        let header_show_hide = true;
        const cur_url = new URL(window.location.href);
        if ((cur_url.pathname === '/login') || (cur_url.pathname.match(/password-reset/g))) {
            header_show_hide = false;
        }

        return (
            <Fragment>
                <header className="montserrat site-header">
                    <div className="mob_menu_wrapper d-sm-block d-md-none">
                        <div className="site_menu_wrapper_inner">
                            <div className="mob_site_menu" onClick={this.showMobSideMenu}>
                                <ul className="mob_site_content">
                                    {
                                        this.props.auth.isAuthenticated ?
                                            <Fragment>
                                                <li key={Math.random()}>
                                                    <NavLink activeClassName="active" className="menu_item" to="/" exact >Livechat</NavLink>
                                                </li>
                                                <li key={Math.random()}>
                                                    <button id="logoutUser" onClick={this.logout} style={{ marginRight: '0' }} className="menu_item nav-link"> Logout</button>
                                                </li>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <li key={Math.random()}>
                                                    <NavLink activeClassName="active" style={{ marginRight: '0' }} className="menu_item" to="/login" exact > Login</NavLink>
                                                </li>
                                            </Fragment>
                                    }
                                </ul>
                            </div>
                            <div className="mob_main_user" onClick={this.showMenu}>
                                {
                                    this.state.showusermenu ?
                                        <div className="mob_main_user_wrapper">
                                            <ul>
                                                <li><NavLink to="/">My Account</NavLink></li>
                                            </ul>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        </div>

                        <div className="clearfix"></div>
                        <p className="mob_text_order topemailphonecolor">Reach us at <a href={`mailto:${email}`}>{email}</a> or <a href={`tel:${phone}`}>{phone}</a></p>
                        <div className="mob_header_logo">
                            <NavLink to="/my-account" exact strict>
                                <img src={require("../../Assets/images/usealan_logo.png").default} alt="ALAN" />
                            </NavLink>
                        </div>
                        <div className="clearfix"></div>
                    </div>

                    <div className={"hide_small_screen header-container " + (this.state.show_header ? '' : 'decrease-height')}>
                        <div className="container">
                            {
                                header_show_hide ?
                                    <div className={this.state.show_header ? 'header-show-hide d-none' : 'header-show-hide hide'} onClick={this.toggleHeader}></div>
                                    : ''
                            }
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="logo-wrapper">
                                        <div className="row">
                                            <div className="col-md-6 d-flex">
                                                <div className="site-logo header-logo-container">
                                                    <NavLink title="ALAN - Live Chat" activeClassName='active' to="/" exact>
                                                        <img src={require("../../Assets/images/logotype-blue.svg").default} className="attachment-full size-full" alt="ALAN - Live Chat" title="ALAN" />
                                                    </NavLink>
                                                    <small className="appVersion">v{APP_VERSION}</small>
                                                </div>
                                                {
                                                    this.props.auth.isAuthenticated ?
                                                        <div className="header-top-menu">
                                                            <ul>
                                                                <li key={Math.random()} className="pr-4">
                                                                    <FontAwesomeIcon icon={faIcon.faUser} /> Live Lead: <strong><span id="liveLead">{this.props.hasOwnProperty('liveLeadCount') ? this.props.liveLeadCount : 0}</span></strong>
                                                                </li>
                                                                <li key={Math.random()} className="border-0">
                                                                    <label>
                                                                        <span>Auto Assign </span>
                                                                        <Switch
                                                                            onChange={() => this.setisAutoAssignable()}
                                                                            checked={this.state.isAutoAssignable}
                                                                            className="react-switch"
                                                                            height={15}
                                                                            width={30}
                                                                        />
                                                                    </label>
                                                                </li>
                                                                <li key="mute" className="mutesound">
                                                                    Mute Sound {this.state.isMute ? <i onClick={() => this.setMute()} className="fas fa-volume-mute"></i> : <i className="fas fa-volume-up text-success" onClick={() => this.setMute()}></i>} : <strong onClick={() => this.setMute()}>{this.state.isMute ? "Yes" : "No"}</strong>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        :
                                                        ''
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                {
                                                    this.props.auth.isAuthenticated ?
                                                        <div className="header-top-menu" style={{ width: '100%' }}>
                                                            <ul className="text-left" style={{ width: '45%' }}>
                                                                {
                                                                    this.state.isFullStory !== "hide" ?
                                                                        <li className="border-0 text-left">
                                                                            <label className="full_story">
                                                                                <span>Full Story </span>
                                                                                <Switch
                                                                                    onChange={() => this.setisFullStory()}
                                                                                    checked={this.state.isFullStory === "no" ? false : true}
                                                                                    className="react-switch"
                                                                                    height={15}
                                                                                    width={30}
                                                                                />
                                                                            </label>
                                                                        </li>
                                                                        :
                                                                        ''
                                                                }
                                                            </ul>
                                                            <ul className="text-right" style={{ width: '55%' }}>
                                                                <UserDetails />
                                                                <ChangePassword />
                                                                <li className={''}>
                                                                    <button onClick={this.logout} className="nav-link" href="#">Logout</button>
                                                                </li>
                                                                <small id="timenow" className={this.state.show_header ? '' : 'd-none'}>
                                                                </small>
                                                            </ul>
                                                        </div>
                                                        :
                                                        <Fragment>
                                                            {/* without auth stuff goes here  */}
                                                        </Fragment>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section id="scrollTop">
                            <div className="site_menu">
                                <div className="header-logo-fix">
                                    <NavLink to="/" exact strict>
                                        <img src={require("../../Assets/images/logotype-blue.svg").default} alt="Alan" title="" />
                                    </NavLink>
                                </div>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <nav className="primary-nav">
                                                <div className="menu-main-menu-container">
                                                    <ul id="menu-main-menu" className="menu">

                                                        {
                                                            this.props.auth.isAuthenticated ?
                                                                <Fragment>

                                                                    <li key={Math.random()}>
                                                                        <NavLink activeClassName="active" className="menu_item" to="/" exact >My Account</NavLink>
                                                                    </li>
                                                                    <li key={Math.random()}>
                                                                        <NavLink activeClassName="active" className="menu_item" to="/" exact >Livechat</NavLink>
                                                                    </li>
                                                                </Fragment>
                                                                :
                                                                <Fragment>
                                                                    <li className="pull-right" key={Math.random()}>
                                                                        <NavLink activeClassName="active" style={{ marginRight: '0' }} className="menu_item" to="/login" exact > Login</NavLink>
                                                                    </li>
                                                                </Fragment>
                                                        }
                                                    </ul>
                                                </div>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </header>

            </Fragment>
        );
    }
}

Header.propTypes = {
    logout: PropTypes.func.isRequired,
    mutesound: PropTypes.func.isRequired,
    autoassign: PropTypes.func.isRequired,
    setfullstory: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        isAutoAssignable: state.auth.isAutoAssignable,
        isFullStory: state.auth.isFullStory,
        liveLeadCount: state.auth.liveLeadCount,
        leadProcessStatus: state.leadProcessStatus,
    };
}

export default withRouter(connect(mapStateToProps, { logout, mutesound, autoassign, setfullstory, setLeadProcessStatus })(Header));